import React from "react";
import { Container } from "react-bootstrap";
import Header from "../Header/Header";
const NotFound = () => {
  return (
    <div>
      <Header></Header>
      <Container fluid>
        <img
          className="img-fluid"
          src="https://i.ibb.co/Kycch85/NotFound.jpg"
          alt=""
        />
      </Container>
    </div>
  );
};

export default NotFound;
